app.modules.offerListWidget = ((self = {}) => {
  const VISIBLE_SLIDES = 6;
  const SLIDER_ITEM_WIDTH = 220;
  const SLIDER_BUTTON_CLASS = 'js-slider-root-widget-button';

  const _updateTransform = (slider, newTransform) => {
    const sliderContainer = slider.querySelector(
      '.js-slider-root-widget-slider-container'
    );
    slider.dataset.transform = newTransform;
    sliderContainer.style.transform = `translateX(-${newTransform}px)`;
  };

  const _toggleVisibilityClass = (slider, action, state) => {
    slider
      .querySelector(`.${SLIDER_BUTTON_CLASS}[data-action="${action}"]`)
      .classList.toggle('dn', state);
  };

  const _updateButtonVisibility = (slider, transformX, maxTransform) => {
    _toggleVisibilityClass(slider, 'next', transformX > maxTransform);
    _toggleVisibilityClass(slider, 'back', transformX === 0);
  };

  const _handleSliderButtonClick = (event) => {
    const {target} = event;
    if (!target.classList.contains(SLIDER_BUTTON_CLASS)) return;

    const slider = target.closest('.js-slider-root-widget');
    let transformX = Number(slider.dataset.transform);
    const itemsToShow = slider.dataset.size - VISIBLE_SLIDES;
    const maxTransform = itemsToShow * SLIDER_ITEM_WIDTH;

    if (target.dataset.action === 'back' && transformX > 0) {
      transformX -= SLIDER_ITEM_WIDTH;
      _updateTransform(slider, transformX);
    } else if (target.dataset.action === 'next' && transformX <= maxTransform) {
      transformX += SLIDER_ITEM_WIDTH;
      _updateTransform(slider, transformX);
    }

    _updateButtonVisibility(slider, transformX, maxTransform);
  };

  const _addListeners = () => {
    document.addEventListener('click', _handleSliderButtonClick);
  };

  self.load = _addListeners;

  return self;
})(app.modules.companySlider);
